import { useEffect, useCallback } from "react";
import { Button } from "@/components/Buttons/index";
import { useMounted, useModal, useAuthUserQuery } from "@/hooks";
import routes from "@/lib/routes";
import { useRouter } from "next/router";
import styles from "@/styles/Modal.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function ProfileSwitchModal() {
  var router = useRouter();

  var _useModal = useModal(),
      hideModal = _useModal.hideModal;

  var handleClick = useCallback(function () {
    hideModal();
    router.push(routes.profileSwitch(true));
  }, []);
  var handleBack = useCallback(function () {
    return router.back();
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      className: styles.text,
      children: "\u3053\u306E\u64CD\u4F5C\u306F\u30AA\u30FC\u30CA\u30FC\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3067\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttons,
      children: [/*#__PURE__*/_jsx(Button, {
        large: true,
        fillGray: true,
        borderGray: true,
        onClick: handleBack,
        children: "\u623B\u308B"
      }), /*#__PURE__*/_jsx(Button, {
        large: true,
        fillColor: true,
        fontFixed: true,
        onClick: handleClick,
        children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u9078\u629E"
      })]
    })]
  });
}

export function useRequireLogin() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    ownerOnly: false
  };
  var router = useRouter();
  var mounted = useMounted();

  var _useModal2 = useModal(),
      showModal = _useModal2.showModal;

  var _useAuthUserQuery = useAuthUserQuery(),
      data = _useAuthUserQuery.data,
      loading = _useAuthUserQuery.loading;

  useEffect(function () {
    if (mounted && !loading) {
      if (data !== null && data !== void 0 && data.user) {
        var _data$user, _data$user$currentPro;

        if (option.ownerOnly && data !== null && data !== void 0 && data.user.currentProfile && !(data !== null && data !== void 0 && (_data$user = data.user) !== null && _data$user !== void 0 && (_data$user$currentPro = _data$user.currentProfile) !== null && _data$user$currentPro !== void 0 && _data$user$currentPro.ownerProfile)) {
          showModal( /*#__PURE__*/_jsx(ProfileSwitchModal, {}), {
            style: "dialogue",
            closeButton: false,
            outerAreaClose: false
          });
        }
      } else {
        router.push(routes.login);
      }
    }
  }, [mounted, loading, data === null || data === void 0 ? void 0 : data.user, option.ownerOnly]);
}